module.exports = __webpack_public_path__ + "assets/img/ic-bill.cd4996e8.svg";